<template>
  <div v-if="projet">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('editionProjet.title', { libelle: projet.libelle }) }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
            <div class="level-right">
              <div class="is-pulled-right buttons boutonAction">
                <a class="button is-addOrEdit"
                   @click="popUpEditProjet = true">
                  {{ $t('general.button.edit')}}
                </a>
              </div>
            </div>
          </div>
      </div>
    </div>

    <!-- Affichage du header-->
    <div class="columns mgt-20px is-vcentered">
      <div class="column is-narrow has-text-weight-bold">
        <span class="is-size-4">{{ projet.libelle }}</span>
      </div>
      <div class="column is-narrow is-cursor-pointer
      has-text-weight-bold" @click="popUpNewFolder = true">
        <span class="is-underline has-text-default">
          {{ $t('editionProjet.addFolder') }}
        </span>
      </div>
      <div class="full-width column">
        <div class="columns is-marginless is-justify-content-end is-vcentered">
          <div class="column is-narrow">
            <qd-progress :value="getPercent" type="is-primary" class="width-100">
            </qd-progress>
          </div>
          <div class="column is-narrow width-60px">
            {{ $t('editionProjet.ligneDossier.slider', {done: getNumberTaskDone,
            total: getNumberTask}) }}
          </div>
        </div>
      </div>
    </div>

    <div class="columns" v-if="projet.dossiers.length === 0">
      <div class="column is-12">
        <div class="card-article-any has-text-centered has-background-white">
          <h1 class="title is-size-3 pdt-50px">
            {{ $t('editionProjet.noDossier')}}
          </h1>
        </div>
      </div>
    </div>

    <div v-for="(dossier, index) in projet.dossiers" :key="dossier.id"
         :class="index > 0 ? 'mgt-25px' : ''">
      <!-- Affichage de la ligne du dossier-->
      <ligne-dossier :dossier="dossier" @refresh="loadProject"></ligne-dossier>

      <!-- Affichage des OT -->
      <div v-if="dossier.open && dossier.ots.length > 0">
        <div v-for="ot in dossier.ots" :key="ot.id">
          <ligne-ot :ot="ot"></ligne-ot>
        </div>
      </div>
      <div v-else-if="dossier.ots.length === 0 && dossier.open">
        <ligne-ot :ligneSansOt="true"></ligne-ot>
      </div>
    </div>

    <b-modal v-model="popUpNewFolder" has-modal-card class="modal">
      <add-folder @refresh="loadProject" :projetId="$route.params.id">
      </add-folder>
    </b-modal>
    <b-modal v-model="popUpEditProjet" has-modal-card class="modal">
      <pop-up-ajout-projet @refresh="loadProject" :projetActuel="projet">
      </pop-up-ajout-projet>
    </b-modal>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import { get } from '@/api/logistique/projets/index';
import breadcrumb from '@/components/general/breadcrumb';
import addFolder from '@/components/logistique/projets/p_addFolder';
import ligneDossier from '@/components/logistique/projets/ligneDossier';
import ligneOt from '@/components/logistique/projets/ligneOt';
import popUpAjoutProjet from '@/components/logistique/projets/p_ajoutProjet';

export default {
  name: 'm_projet',
  data() {
    return {
      projet: null,
      popUpNewFolder: false,
      popUpEditProjet: false,
    };
  },
  components: {
    breadcrumb,
    addFolder,
    ligneDossier,
    ligneOt,
    popUpAjoutProjet,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('editionProjet.breadcrumb.listeProjet'), route: { name: 'l.logistique.projets' }, isActive: false },
        { title: this.$t('editionProjet.breadcrumb.projet', { libelle: this.projet.libelle }), route: '', isActive: true },
      ];
    },
    getNumberTaskDone() {
      let task = 0;
      this.projet.dossiers.forEach((dossier) => {
        dossier.ots.forEach((ot) => {
          task += ot.taches.filter((tache) => { return tache.realise; }).length;
        });
      });
      return task;
    },
    getNumberTask() {
      let task = 0;
      this.projet.dossiers.forEach((dossier) => {
        dossier.ots.forEach((ot) => {
          task += ot.taches.length;
        });
      });
      return task;
    },
    getPercent() {
      if (this.projet.dossiers.length === 0 || this.getNumberTask === 0) return 0;
      return (this.getNumberTaskDone * 100) / this.getNumberTask;
    },
  },
  methods: {
    async loadProject() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const projet = (await get(this.$route.params.id)).data.result;
        projet.dossiers.forEach((dossier) => {
          dossier.open = true;
        });
        this.projet = projet;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    await this.loadProject();
    this.setInformationPage(this.$t('pageLogistique.projet.edition'));
  },
};
</script>

<style scoped>

</style>
